module.exports = __webpack_public_path__ + "img/Open ticket.6a72ed4c.png";